export default __webpack_public_path__ + "static/media/connections.709c4a04.svg";